/**************************************************
 * Nombre:       Tarjeta_Cabecera_Columna
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {Add} from '@mui/icons-material'
import {theme} from "../../../Tema";
import {formatoMonedaTabla} from "../../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjeta_Cabecera_Columna = ({item, color = '#646464', click, numero, valor}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderLeft: 3,
                borderColor: color,
                backgroundColor: color + 50,
                borderRadius: 2,
                p: 1,
                color: theme.palette.info.main
            }}
        >

            <Grid container size={10} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 16, fontWeight: 600}}>{item}</Typography>
            </Grid>

            <Grid container size={2} sx={{justifyContent: 'flex-end'}}>
                <IconButton
                    onClick={() => click({estado: item})}
                    sx={{p: 0}}>
                    <Add/>
                </IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 12, color: theme.palette.info.main + 90}}>
                    <span style={{fontWeight: 600, paddingRight: 5, color: theme.palette.info.main}}>
                        {numero}
                    </span>
                    {`Oportunidades ${formatoMonedaTabla(valor)}`}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Cabecera_Columna